module.exports = __webpack_public_path__ + "img/account-logout.2364b51c.svg";